import { IOS_USER_AGENT_PATTERN } from './get-device-by-user-agent';

export const isIOSApproaching = () => {
  if (typeof window === 'undefined') return;

  const userAgent = navigator.userAgent.toLowerCase();

  return userAgent.match(IOS_USER_AGENT_PATTERN);
};
